import { React, useEffect } from "react";
import "./Planos.scss";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import IconeAtivo from "../../../assets/images/home/icone_ativo.png";
import { useHistory } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";

const Planos = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  let history = useHistory();
  return (
    <>
      <div className="view-planos">
        <Container>
          <div className="botao-topo">
            <button>Contamos com versão Web e Mobile</button>
          </div>
          <div data-aos="fade-up" className="planos">
            <Grid
              container
              spacing={window.screen.availWidth <= 768 ? 0 : 12}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item md={4} xs={12} display="flex" justifyContent="center">
                <div className="plano" onClick={
                  () => {
                    history.push("/");
                    setTimeout(() => {
                      document.getElementById("form-home").scrollIntoView({
                        behavior: "smooth",
                      });
                    }, 300);
                  }
                }>
                  <div className="topo"></div>
                  <div className="texto">
                    <div className="titulo">Módulo</div>
                    <span>ORÇAMENTO</span>
                  </div>
                  <div className="botao-final">
                    <div className="botao">CONSULTAR VALORES</div>
                  </div>
                </div>
              </Grid>
              <Grid item md={4} xs={12} display="flex" justifyContent="center">
                <div className="plano" onClick={
                  () => {
                    history.push("/");
                    setTimeout(() => {
                      document.getElementById("form-home").scrollIntoView({
                        behavior: "smooth",
                      });
                    }, 300);
                  }
                }>
                  <div className="topo"></div>
                  <div className="texto">
                    <div className="titulo">Módulo</div>
                    <span>ORÇAMENTO + FLUXO DE TRABALHO</span>
                  </div>
                  <div className="botao-final">
                    <div className="botao">CONSULTAR VALORES</div>
                  </div>
                </div>
              </Grid>
              <Grid item md={4} xs={12} display="flex" justifyContent="center">
                <div className="plano" onClick={
                  () => {
                    history.push("/");
                    setTimeout(() => {
                      document.getElementById("form-home").scrollIntoView({
                        behavior: "smooth",
                      });
                    }, 300);
                  }
                }>
                  <div className="topo"></div>
                  <div className="texto">
                    <div className="titulo">Módulo</div>
                    ORÇAMENTO + FLUXO DE TRABALHO + FINANCEIRO
                  </div>
                  <div className="botao-final">
                    <div className="botao">CONSULTAR VALORES</div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="informativos">
            Após adesão de seu plano realizamos um treinamento personalizado para toda equipe.
          </div>
          <div className="icone">
            <img src={IconeAtivo} alt="Icone" />
          </div>
          <div className="ajudar">
            Estamos aqui para te ajudar <br /> a descomplicar a gestão <br /> da
            sua empresa!
          </div>
        </Container>
      </div>
    </>
  );
};

export default Planos;
